export const insuredPetOptionNames = [
  'birthDate',
  'gender',
  'healthCondition',
  'mixedBreed',
  'firstBreed',
  'secondBreed'
]
